import { Controller } from "@hotwired/stimulus";

// Connects to data-controller="modal"
export default class extends Controller {
  static targets = [];

  close() {
    const frame = this.element.closest("turbo-frame#add_item_modal_frame");
    if (frame) {
      frame.innerHTML = "";
    }
  }
}
